import Vue from "vue";
import App from "./App.vue";

import router from "./router/index";

import "animate.css";

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
Vue.use(VueAwesomeSwiper);

import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
  },
});

Vue.directive("inview", {
  inserted(el, binding) {
    const { value } = binding; // value 为动画类名（如 'fadeInUp'）
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.classList.add("animate__animated", value); // 添加动画类
            observer.unobserve(el); // 触发后停止观察
            // 如需重复触发，移除本行，并添加动画结束后重置逻辑
          }
        });
      },
      {
        rootMargin: "0px 0px -200px 0px", // 延迟 200px 触发
        threshold: 0.1,
      }
    );
    observer.observe(el);
  },
});

Vue.config.productionTip = false;

const mask = document.createElement("div");
mask.className = "body-mask";

// 将遮罩插入到 body 中
document.body.appendChild(mask);

Vue.prototype.$mask = {
  element: mask, // 遮罩 DOM 元素
  show() {
    this.element.style.display = "block"; // 显示遮罩
  },
  hide() {
    this.element.style.display = "none"; // 隐藏遮罩
  },
};

new Vue({
  render: (h) => h(App),
  router,
  beforeCreate() {
    Vue.prototype.$bus = this;
  },
}).$mount("#app");
